<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import { useDeviceStore } from '@/stores/device.js';

export default {
  name: 'App',
  mounted() {
    const deviceStore = useDeviceStore();
    deviceStore.update();

    // 定义 resize 处理函数，并保存引用以便移除
    this.handleResize = () => deviceStore.update();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    // 组件卸载前移除监听器
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  
}

.el-carousel__container {
  height: 100% !important;
}
</style>



